import { JSX } from "react";
import { $applyNodeReplacement, DecoratorNode, DOMConversionMap, DOMConversionOutput, EditorConfig, LexicalEditor, LexicalNode, NodeKey, SerializedLexicalNode, Spread } from "lexical";
import {
    DecoratorBlockNode,
    SerializedDecoratorBlockNode,
} from '@lexical/react/LexicalDecoratorBlockNode';

export type SerializedEquationNode = Spread<
    {
        latex: string;
        svg: string;
    },
    SerializedLexicalNode
>;
export function $createEquationNode(svg: string, latex: string): EquationNode {
    return new EquationNode(svg, latex)
}

export class EquationNode extends DecoratorNode<JSX.Element> {
    __svg: string;
    __latex: string;
    constructor(svg: string, latex: string, key?: NodeKey) {
        super(key)
        this.__svg = svg;
        this.__latex = latex;
    }

    static getType(): string {
        return 'equation';
    }

    static importJSON(serializedNode: SerializedEquationNode): EquationNode {
        return $createEquationNode(serializedNode.svg, serializedNode.latex).updateFromJSON(serializedNode);
    }


    exportJSON(): SerializedEquationNode {
        return {
            ...super.exportJSON(),
            svg: this.__svg,
            latex: this.__latex
        };
    }

    getLatex(): string {
        return this.__latex;
    }

    static importDOM(): DOMConversionMap | null {
        return {
            img: (node: Node) => ({
                conversion: $convertEquationNode,
                priority: 0,
            }),
        };
    }

    updateDOM(): false {
        return false;
    }

    isInline(): boolean {
        return true
    }
    
    createDOM(config: EditorConfig): HTMLElement {
        const img = document.createElement('img');
        img.className = "equation";
        img.src = `data:image/svg+xml;utf8,${this.__svg}`
        img.dataset["latex"] = this.__latex;
        return img;
    }

    static clone(node: EquationNode): EquationNode {
        return new EquationNode(node.__svg, node.__latex, node.__key);
    }

    decorate(editor: LexicalEditor, config: EditorConfig): JSX.Element {
        return <img className="equation" src={`data:image/svg+xml;utf8,${this.__svg}`} data-latex={this.__latex} />
    }
};

function $convertEquationNode(element: HTMLElement): DOMConversionOutput {
  let node: EquationNode | null = null;
  if(element.classList.contains("equation") && element instanceof HTMLImageElement) {
    let latex   = element.dataset["latex"];
    let svg = element.src.replace(/data:image\/svg\+xml;utf8,/, '')
    if(svg && latex) {
        node = $applyNodeReplacement(new EquationNode(svg, latex)) 
    }
  }
  return {node}
}

export function isEquationNode(node: LexicalNode) {
    return node instanceof EquationNode;
}
